import React from "react";
import {useAuth} from "../../../context";
import {LogOut} from "lucide-react";
import {useNavigate} from "react-router-dom";

export function LogoutButton({ onClick: onClickCallback }: { onClick?: () => void }) {
    const { isAuthenticated, logout } = useAuth();
    const navigate = useNavigate();

    function onClick() {
        if (isAuthenticated) {
            logout();
        }

        onClickCallback?.();

        navigate('/login');
    }

    return (
        <button
            onClick={onClick}
            className="p-2 text-gray-400 hover:text-gray-500"
        >
            <LogOut className="h-6 w-6" />
        </button>
    );
}
